import styled, {DefaultTheme} from 'styled-components';

import {mixins} from '../styles';

type TCircularProgressBarProps = {
  size: number;
};

export const CircularProgressBar = styled.div<TCircularProgressBarProps>`
  position: relative;
  ${({size}: TCircularProgressBarProps) => mixins.wh(`${size}px`)}
`;

export const Progress = styled.circle<{color?: keyof DefaultTheme['palette']}>`
  fill: none;
  stroke: ${({theme, color}) => (color ? theme.palette[color] : theme.palette.white)};
  stroke-linecap: round;
  stroke-linejoin: round;
`;

export const Children = styled.div`
  ${mixins.position({position: 'absolute', top: 0, left: 0})}
  ${mixins.flexAlign('center')}
  ${mixins.wh('100%')}
`;
